var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.3 2.343-3.897 3.68 3.865 3.304a.688.688 0 0 0 .032-.206V2.343ZM1.274 9.799a.7.7 0 0 0 .126.011h11.2c.05 0 .1-.005.148-.015L8.896 6.503l-.693.654a1.414 1.414 0 0 1-1.897.038l-.824-.72L1.274 9.8Zm.126-8.61a.703.703 0 0 0-.576.298L6.77 6.68c.273.237.686.23.949-.02l5.464-5.162a.702.702 0 0 0-.583-.307H1.4ZM.7 9.122c0 .076.013.15.036.219L4.95 6.01.7 2.301v6.82Zm13.3 0a1.39 1.39 0 0 1-1.4 1.379H1.4A1.39 1.39 0 0 1 0 9.12V1.88C0 1.117.627.5 1.4.5h11.2c.773 0 1.4.618 1.4 1.38v7.24Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h14v10H0z"
  })))));
};
export default SvgEmail;